<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile">
  <div class="d-flex justify-content-between">
    <div class="zero-text p-bigger-med">
      {{ 'statistics.trade-ticker.headline' + (instrumentTypeOnly ? '-' + instrumentTypeOnly : '') | transloco }}
    </div>
    <web-design-system-icon-button (click)="collapse()" type="grey-light" size="small" [icon]="collapsed() ? 'chevron' : 'chevron-2'" />
  </div>
  @if (!collapsed()) {
    @if (!instrumentTypeOnly) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="filters d-flex">
            <span
              class="badge badge-primary mr-2 cursor-pointer no-select zero-text p-small-reg"
              [class.active]="!filter"
              (click)="filterChange.emit(null)"
            >
              {{ 'statistics.trade-ticker.filters.all' | transloco }}
            </span>
            @for (f of filters; track $index) {
              <span
                class="badge badge-primary mr-2 cursor-pointer no-select zero-text p-small-reg"
                [class.active]="filter === f"
                (click)="filterChange.emit(f)"
              >
                {{ 'statistics.trade-ticker.filters.' + f | transloco }}
              </span>
            }
          </div>
        </div>
      </div>
    }
    <div class="row mt-3">
      <div class="col-12">
        <table class="table-simple" aria-describedby="trade-ticker">
          <thead class="hidden-xs hidden-sm visible-md">
            <tr class="etp-header">
              <th>{{ 'statistics.trade-ticker.labels.name' | transloco }}</th>
              @if (!instrumentTypeOnly) {
                <th class="text-right">{{ 'statistics.trade-ticker.labels.type' | transloco }}</th>
              }
              <th class="text-right">{{ 'statistics.trade-ticker.labels.qty' | transloco }}</th>
              <th class="text-right">{{ 'statistics.trade-ticker.labels.quote' | transloco }}</th>
              <th class="text-right">{{ 'statistics.trade-ticker.labels.volume' | transloco }}</th>
              <th class="text-right">{{ 'statistics.trade-ticker.labels.time' | transloco }}</th>
            </tr>
          </thead>
          @if (loading) {
            <tbody>
              @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track $index) {
                <tr>
                  <td colspan="6">
                    <div class="loading-shimmer trade-tick"></div>
                  </td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody class="opacity-container" [class.active]="trades?.length" [@listAnimation]="trades">
              @for (trade of trades; track trade.execDateTime) {
                <tr data-zid="trade-tick" [routerLink]="[instrumentDetailsUrl, trade.isin]">
                  <td class="d-block d-md-table-cell">
                    <div class="d-flex">
                      <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'statistics.trade-ticker.labels.name' | transloco }}
                      </div>
                      <div class="text-md-left text-right zero-text p-base-med">
                        {{ trade.instrumentName }}
                      </div>
                    </div>
                  </td>
                  @if (!instrumentTypeOnly) {
                    <td class="d-block d-md-table-cell">
                      <div class="d-flex justify-content-end">
                        <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                          {{ 'statistics.trade-ticker.labels.type' | transloco }}
                        </div>
                        <div class="text-color-primary">
                          {{ trade.instrumentType }}
                        </div>
                      </div>
                    </td>
                  }
                  <td class="d-block d-md-table-cell">
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'statistics.trade-ticker.labels.qty' | transloco }}
                      </div>
                      <div class="text-color-primary">
                        {{ trade.quantity | number: '1.0-6' }}
                      </div>
                    </div>
                  </td>
                  <td class="d-block d-md-table-cell">
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'statistics.trade-ticker.labels.quote' | transloco }}
                      </div>
                      <div class="text-color-primary">
                        {{ trade.entryQuote | currency }}
                      </div>
                    </div>
                  </td>
                  <td class="d-block d-md-table-cell">
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'statistics.trade-ticker.labels.volume' | transloco }}
                      </div>
                      <div class="text-color-primary">
                        {{ trade.volume | currency }}
                      </div>
                    </div>
                  </td>
                  <td class="d-block d-md-table-cell">
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'statistics.trade-ticker.labels.time' | transloco }}
                      </div>
                      <div class="text-color-primary">
                        {{ trade.execDateTime | todayTimeOrDate }}
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
            @if (!trades?.length) {
              <tbody>
                <tr>
                  <td colspan="6">
                    {{ 'statistics.trade-ticker.no-data' | transloco }}
                  </td>
                </tr>
              </tbody>
            }
          }
        </table>
      </div>
    </div>
  }
</div>
